export default function R_Recursion() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Recursion Component</h1>
      <p>This is the R_Recursion tutorial section.</p>
    </div>
  );
}
